import React from 'react';
import { UserIcon, MailIcon, GlobeIcon, ShoppingCartIcon, TrendingUpIcon, CpuIcon, TagIcon, DollarSignIcon, LinkedinIcon } from 'lucide-react';
export function EcommerceFields() {
  return <section className="py-24 bg-slate-50" data-id="element-1059">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1060">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-1061">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6 leading-tight" data-id="element-1062">
            Comprehensive{' '}
            <span className="text-blue-600" data-id="element-1063">e-commerce store data</span>
          </h2>
          <p className="text-xl text-slate-600" data-id="element-1064">
            Our e-commerce leads database provides deep Shopify statistics,
            technographic data, and verified store owner emails — so you can
            reach the exact decision maker every time.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-1065">
          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-1066">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-1067">
              <GlobeIcon className="w-6 h-6" data-id="element-1068" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-1069">
              Store domain & URL
            </h3>
            <p className="text-slate-600" data-id="element-1070">
              Direct links to the e-commerce storefronts and active domains.
            </p>
          </div>

          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-1071">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-1072">
              <MailIcon className="w-6 h-6" data-id="element-1073" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-1074">
              Store owner emails
            </h3>
            <p className="text-slate-600" data-id="element-1075">
              Direct store owner emails and employee lists, verified in
              real-time.
            </p>
          </div>

          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-1076">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-1077">
              <ShoppingCartIcon className="w-6 h-6" data-id="element-1078" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-1079">
              E-commerce platform
            </h3>
            <p className="text-slate-600" data-id="element-1080">
              Filter by Shopify, WooCommerce, BigCommerce, Magento, Wix, etc.
            </p>
          </div>

          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-1081">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-1082">
              <TagIcon className="w-6 h-6" data-id="element-1083" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-1084">
              Product count
            </h3>
            <p className="text-slate-600" data-id="element-1085">
              Number of active products listed on the storefront.
            </p>
          </div>

          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-1086">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-1087">
              <TrendingUpIcon className="w-6 h-6" data-id="element-1088" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-1089">
              Reviews & ratings
            </h3>
            <p className="text-slate-600" data-id="element-1090">
              Customer review counts and average ratings to gauge store
              reputation.
            </p>
          </div>

          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-1091">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-1092">
              <CpuIcon className="w-6 h-6" data-id="element-1093" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-1094">
              Technology stack
            </h3>
            <p className="text-slate-600" data-id="element-1095">
              900+ technologies tracked including apps, analytics, and payments.
            </p>
          </div>

          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-1096">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-1097">
              <UserIcon className="w-6 h-6" data-id="element-1098" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-1099">
              Store category
            </h3>
            <p className="text-slate-600" data-id="element-1100">
              Browse our full list of categories — Shopify apparel stores,
              Electronics, Food & Beverage, Beauty, Home & Garden, and more.
            </p>
          </div>

          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-1101">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-1102">
              <DollarSignIcon className="w-6 h-6" data-id="element-1103" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-1104">
              Revenue estimates
            </h3>
            <p className="text-slate-600" data-id="element-1105">
              Estimated annual revenue to qualify your e-commerce leads.
            </p>
          </div>

          <div className="p-6 rounded-2xl bg-white border border-slate-200" data-id="element-1106">
            <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4 text-blue-600" data-id="element-1107">
              <LinkedinIcon className="w-6 h-6" data-id="element-1108" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-1109">
              Social profiles
            </h3>
            <p className="text-slate-600" data-id="element-1110">
              Instagram, TikTok, Facebook, and LinkedIn profiles for the brand.
            </p>
          </div>
        </div>
      </div>
    </section>;
}